import SignUpContainer from "./SignUpContainer";
import SignUpStore from "./SignUpStore";
export default SignUpStore(SignUpContainer);
